//Modal for editing a protectee
import React from 'react'

export const AccountModal = ({ isOpen, onClose}) => {
    if (!isOpen) return null;
    
    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0, 0, 0, 0.75)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <div className='modalComponents'
                style={{
                    background: "var(--tertiaryBackgroundColor)",
                    height: "50vh",
                    width: "30vw",
                    margin: "auto",
                    padding: "2%",
                    border: "2px solid #000",
                    borderRadius: "10px",
                    boxShadow: "2px solid black",
                }}
            >
                <div className="toolbar">
                    <button className="customButton" onClick={onClose}>Close</button>
                </div>
                <div className="header">
                    <h2>My Account</h2>
                </div>
                <div className="body">
                    <p>Reset Password</p>
                    <p>Settings</p>
                    <p>Privacy</p>
                </div>
            </div>
        </div>
    )
  }
